import { render, staticRenderFns } from "./integralTask.vue?vue&type=template&id=3eaa640b&scoped=true"
import script from "./integralTask.vue?vue&type=script&lang=js"
export * from "./integralTask.vue?vue&type=script&lang=js"
import style0 from "./integralTask.vue?vue&type=style&index=0&id=3eaa640b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaa640b",
  null
  
)

export default component.exports